export default {
    eventTicketsData: {},
    listEventTickets: {}
}